import styled from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/common';

enum Direction {
    Horizontal = 'Horizontal',
    Vertical = 'Vertical',
}
interface Props {
    direction: Direction;
    collapsedSize: number;
}

export const ExpandableBoxElement = styled.div<Props>`
    overflow-y: hidden;
    ${(props) =>
        props.direction === Direction.Horizontal
            ? `
                width: ${props.collapsedSize}px;
                transition: width ${ANIMATION_DURATION.fast}ms ${ANIMATION_CURVE.default};
            `
            : `
                height: ${props.collapsedSize}px;
                transition: height ${ANIMATION_DURATION.fast}ms ${ANIMATION_CURVE.default};
            `}
`;
